import { makeAutoObservable } from "mobx";
import {
  JudgmentIntegration,
  IntegrationCategory,
  ProcessStatus,
  JudgmentIntegrationCase,
} from "../types/JudgmentIntegrationTypes";

export class JudgmentStore {
  judgmentIntegrations: JudgmentIntegration[] | undefined;
  currentIntegration: JudgmentIntegration | undefined;
  showPastIntegrationsTable: boolean = true;
  showImportForm: boolean = false;
  showImportResultsTable: boolean = false;
  isEditing: boolean = false;

  constructor() {
    makeAutoObservable(this);
  }

  setInitialView() {
    this.currentIntegration = undefined;
    this.isEditing = false;
    this.showPastIntegrationsTable = true;
    this.showImportForm = false;
    this.showImportResultsTable = false;
  }

  setEditing = (data: JudgmentIntegration) => {
    this.currentIntegration = data;
    this.isEditing = true;
    this.showPastIntegrationsTable = false;
    this.showImportForm = true;
    this.showImportResultsTable = true;
  }

  setCreating = (category: IntegrationCategory) => {
    this.currentIntegration = {
      id: -1,
      name: "",
      creationDate: undefined,
      cases: [],
      civilEntries: [],
      aliasEntries: [],
      lastUpdated: undefined,
      lastUpdateBy: "",
      civilEntriesFileName: "",
      aliasFileName: "",
      creationUserID: -1,
      creationDateFormatted: "",
      lastUpdatedFormatted: "",
      statusID: ProcessStatus.Imported,
      statusName: "",
      integrationCategoryID: category,
      integrationCategoryName: "",
      canDeleteJudgmentIntegration: false,
    };
    this.isEditing = false;
    this.showPastIntegrationsTable = false;
    this.showImportForm = true;
    this.showImportResultsTable = false;
  }

  setCurrentIntegration(integration: JudgmentIntegration) {
    this.currentIntegration = integration;
  }

  get cases(): JudgmentIntegrationCase[] {
    return this.currentIntegration?.cases || [];
  }
}

export default new JudgmentStore();
